<template>
    <base-modal :closable="closable" :scrollable="true" :adaptive="true" height="auto" width="100%" classes="v--modal my-6" :max-width="600" name="login-modal">
        <div class="px-4 lg:px-0 pt-8">
            <login-form-version-one></login-form-version-one>
        </div>
    </base-modal>
</template>

<script>

    import { mapGetters, mapMutations } from 'vuex'

    export default {

        props: {
            closable: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                modalName: "login-modal"
            }
        },

        computed: {
            ...mapGetters('general', ['getPath', '_'])
        },

        methods: {
            ...mapMutations("modal", ["showModal"]),
        },
    }
</script>
